var _path, _path2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgViewactionclock = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 15.1667C4.04665 15.1667 0.833313 11.9533 0.833313 8C0.833313 4.04666 4.04665 0.833328 7.99998 0.833328C11.9533 0.833328 15.1666 4.04666 15.1666 8C15.1666 11.9533 11.9533 15.1667 7.99998 15.1667ZM7.99998 1.83333C4.59998 1.83333 1.83331 4.6 1.83331 8C1.83331 11.4 4.59998 14.1667 7.99998 14.1667C11.4 14.1667 14.1666 11.4 14.1666 8C14.1666 4.6 11.4 1.83333 7.99998 1.83333Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4733 10.62C10.3867 10.62 10.3 10.6 10.22 10.5467L8.15334 9.31333C7.64001 9.00667 7.26001 8.33333 7.26001 7.74V5.00667C7.26001 4.73333 7.48668 4.50667 7.76001 4.50667C8.03334 4.50667 8.26001 4.73333 8.26001 5.00667V7.74C8.26001 7.98 8.46001 8.33333 8.66668 8.45333L10.7333 9.68667C10.9733 9.82667 11.0467 10.1333 10.9067 10.3733C10.8067 10.5333 10.64 10.62 10.4733 10.62Z",
    fill: "#757575"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgViewactionclock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/viewactionclock.8d137457.svg";
export { ForwardRef as ReactComponent };